import { ReactElement } from 'react';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { formatTranslation } from 'intl';
import { CommonTranslationKeys } from 'intl/keys';
import { useProjectStore } from 'store/project';
import { projectBoxSx, projectLabelSx, projectNameSx } from './styles';

/** The name of the project being opened, above the loading or its failure. */
export function ProjectHeading(): ReactElement {
  const name = useProjectStore((state) => state.data.project.name);
  const intl = useIntl();

  return (
    <Box sx={projectBoxSx}>
      <Box sx={projectLabelSx}>{formatTranslation(intl, CommonTranslationKeys.project)}</Box>
      <Box sx={projectNameSx}>{name}</Box>
    </Box>
  );
}
